<template>
    <b-dropdown variant="outline-orange" :text="selected">
        <b-dropdown-item @click="emitItemSelected(item)" v-for="(item, index) in status" :key="index">
            {{ item }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
  export default {
    data() {
      return {
        status: ['All Status', 'Complete', 'Serving', 'Awaiting'],
        selected: 'All Status'
      }
    },

    methods: {
      /**
       * Emit item selected.
       *
       * @param item
       */
      emitItemSelected(item) {
        console.log(item);
        this.$emit('selected', item);
        this.selected = item;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Common/Filter/AppointmentStatusFilter.vue